import { IsString }   from 'class-validator';

export class TS_Request {
    
    @IsString()
    for : string;
    
    payload : object;
    
}